/* eslint no-param-reassign: 0 */
const DEFAULT_COLOUR_SCHEME = {
  primaryColour: "#25c4cd",
  secondaryColour: "#4a4558",
  bgColour: "#f4f5f7"
};

const initialState = {
  sidenavCollapsed: true,
  rightSideNavCollapsed: true
};

const gettersDef = {
  colorScheme: (state, getters, rootState, rootGetters) => {
    const company = rootGetters["auth/activeCompany"] || {};
    return {
      primaryColour:
        company.primaryColour || DEFAULT_COLOUR_SCHEME.primaryColour,
      secondaryColour:
        company.secondaryColour || DEFAULT_COLOUR_SCHEME.secondaryColour,
      bgColour: company.bgColour || DEFAULT_COLOUR_SCHEME.bgColour
    };
  },
  hasColorScheme: (state, getters, rootState, rootGetters) => {
    const company = rootGetters["auth/activeCompany"];
    if (!company) {
      return false;
    }
    return !!company.primaryColour;
  },
  sidenavCollapsed: state => state.sidenavCollapsed,
  rightSideNavCollapsed: state => state.rightSideNavCollapsed,
  defaultTimezone: (state, getters, rootState, rootGetters) => {
    const company = rootGetters["auth/activeCompany"];
    if (!company) {
      return false;
    }
    return company.defaultTimezone || "Europe/London";
  }
};

const actions = {};

const mutations = {
  toggleSidenav(state) {
    state.sidenavCollapsed = !state.sidenavCollapsed;
    if (!state.rightSideNavCollapsed) {
      state.rightSideNavCollapsed = !state.rightSideNavCollapsed;
    }
  },
  toggleRightSidenav(state) {
    state.rightSideNavCollapsed = !state.rightSideNavCollapsed;
    if (!state.sidenavCollapsed) {
      state.sidenavCollapsed = !state.sidenavCollapsed;
    }
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
